import React from "react";

type ToggleButtonProps = {
  isOn: boolean;
  handleClick: () => void;
  buttonText?: string;
};

const ToggleButton = ({ isOn, handleClick, buttonText = "" }: ToggleButtonProps) => {
  return (
    <div className="flex items-center mt-3 mb-3">
      <button
        type="button"
        onClick={handleClick}
        className={`
          relative inline-flex items-center
          h-[22px] w-[42px]
          rounded-full cursor-pointer transition-all duration-300
          ${isOn ? "bg-[#82c67d]" : "bg-gray-300"}
        `}
      >
        <span
          className={`
            absolute inline-block 
            h-[16px] w-[16px] bg-white rounded-full
            shadow-sm transform transition-all duration-300
            ${isOn ? "translate-x-[22px]" : "translate-x-[4px]"}
          `}
        />
      </button>

    
          <span className="ml-2 text-[14px]">
              {buttonText}
         
        </span>
   
    </div>
  );
};

export default ToggleButton;
